import React, { Component } from 'react'
import { Modal, Button } from 'hljd'
import { goPayment, getProTitle } from '@util'
import style from './index.module.less'
import { observer } from 'mobx-react'
import { toJS } from 'mobx'

@observer
class ProtocolModal extends Component {
  gotoPayment = () => {
    const { flagship_price = {} } = this.props
    const title = `购买${getProTitle()}`
    goPayment({ title, fee: flagship_price.fee })
  }
  render() {
    const purchaseData = toJS(this.props.store.purchaseData)
    const { showModal } = this.props.store
    const { flagship = {}, standard_to_flagship = {} } = purchaseData
    // const { protocol = {} } = flagship
    let protocol = flagship.protocol || {}
    if (standard_to_flagship.is_buy_standard_to_flagship == 0) {
      protocol = standard_to_flagship.protocol
    }
    return (
      <Modal
        title={protocol.protocol_title}
        visible={showModal}
        onOk={this.gotoPayment}
        onCancel={() => this.props.store.setStoreData('showModal', false)}
        okText={`开通${getProTitle()}`}
        keyboard={false}
        width={700}
        wrapClassName={style.versionBox}
        footer={[
          <Button type="primary" key="ok" onClick={this.gotoPayment}>
            我同意遵守协议并继续下单
          </Button>
        ]}
      >
        <div
          style={{
            maxHeight: '500px',
            overflow: 'hidden',
            overflowY: 'auto'
          }}
        >
          <div
            dangerouslySetInnerHTML={{ __html: protocol.protocol_content }}
          />
        </div>
      </Modal>
    )
  }
}

export default ProtocolModal
